export const AppCfg = {
  env: import.meta.env.VITE_ENV,
  isProd: import.meta.env.VITE_ENV.toLowerCase() === "production",

  enableGA: import.meta.env.VITE_ANALYTICS_ENABLED.toLowerCase() === "true",

  platform: "web",
  isNative: false,

  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000",
  landingBaseUrl: import.meta.env.VITE_LANDING_BASE_URL || "https://dev-landing.humanexasia.com",
  clientBaseUrl: import.meta.env.VITE_CLIENT_BASE_URL || "https://dev-candidate.humanexasia.com",
  agentBaseUrl: import.meta.env.VITE_AGENT_BASE_URL || "https://dev-agent.humanexasia.com",
  tenantBaseUrl: import.meta.env.VITE_TENANT_BASE_URL || "https://dev-tenant.humanexasia.com",

  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  }
} as const;
